import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import $ from "jquery";
import "./PPWatchVideo.css";
import Header from "../../../Header/Header";
import Spinner from "../../../Spinner/Spinner";
import { post } from "../../../../app/shared/http.js";
import { handleException } from "../../../../app/util/util";
import loaderColors1 from "../../../Spinner/loaderColors1.gif";
import { PPWatchVideoQuizButtons } from "./PPWatchVideoQuizButtons";
import {
  withAuth,
  handleResponse,
  handleJwtTokenForKeppMeLoggedIn,
} from "../../../../app/util/HOC";
export function PPWatchVideo() {
  const { isbn, subtopictagid } = useParams();
  const isLandingPageInfor = useRef(false);
  const userVO = JSON.parse(localStorage.getItem("userVO"));
  const ppIsbn = isbn ? isbn : localStorage.getItem("bookIsbn");
  const keepMeLogIn = localStorage.getItem("keepLoggedIn") ? "true" : "false";
  const [videoURL, setVideoURL] = useState();
  const [ppVideo, setPPVideo] = useState(null);
  const [videoMode, setVideoMode] = useState("continuous");
  const [isVideoPlayed, setIsVideoPlayed] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const [landingPageInfor, setLandingPageInfor] = useState("");
  const [ppQuizResultVOList, setppQuizResultVOList] = useState([]);
  const [videoOption, setVideoOption] = useState([
    { value: "interactive", label: "Interactive" },
    { value: "continuous", label: "Continuous Play" },
  ]);
  let observer;
  const getSessionVO = () => {
    return {
      appType: "web",
      deviceMacId: "",
      keepMeLoggedInFlag: keepMeLogIn,
      deviceOS: localStorage.getItem("deviceOS"),
      deviceType: localStorage.getItem("deviceType"),
      browserName: localStorage.getItem("browserName"),
      sessionAuthenticationToken: userVO.sessionAuthenticationToken,
    };
  };
  const getPPvideoPagedetails = async () => {
    let reqData = { productISBN: ppIsbn };
    post("/PP/get-PPproductDetails", reqData, "qpAPI")
      .then(handleResponse)
      .then((response) => response.json())
      .then(handleJwtTokenForKeppMeLoggedIn)
      .then((data) => {
        if (data.Exception) {
          handleException(data);
          return false;
        } else {
          if (data.ValidityStatus === "Expired") {
            localStorage.setItem("PPException", data.ValidityStatus);
            window.location.replace(window.location.origin + "/invalidUrl");
            return false;
          }
          localStorage.removeItem("PPException");
          setLandingPageInfor(data);
          localStorage.setItem("ppLandingInfo", JSON.stringify(data));
          localStorage.setItem("ppProductName", data.ProductName);
          localStorage.setItem("ppProductTagId", data.SATagId);
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const getPPVideoTracker = async () => {
    var requestOptions = {
      ppSubjectAreaTagId: landingPageInfor.SATagId,
      ppProductVO: {
        productId: landingPageInfor.ProductID,
      },
      ppSubTopicVO: {
        subTopictagId: subtopictagid,
      },
    };
    post("/managePP/getPPVideoTracker", requestOptions, "ENV")
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "true") {
          setPPVideo(data.ppSubTopicVO);
          let videoURL;
          let videoMode;
          let modeType = data.ppSubTopicVO.modeType;
          let interactiveVideoPath = data.ppSubTopicVO.interactiveVideoPath;
          let continuousVideoPath = data.ppSubTopicVO.continuousVideoPath;
          if (data.ppQuizResultVOList) {
            if (!Array.isArray(data.ppQuizResultVOList)) {
              data.ppQuizResultVOList = [data.ppQuizResultVOList];
            }
            setppQuizResultVOList(data.ppQuizResultVOList);
          }
          if (data.ppSubTopicVO.modeType) {
            if (modeType == "interactive") {
              if (
                interactiveVideoPath == null ||
                interactiveVideoPath == undefined
              ) {
                videoURL = continuousVideoPath;
                videoMode = "continuous";
                setVideoOption([
                  { value: "continuous", label: "Continuous Play" },
                ]);
              } else {
                videoURL = interactiveVideoPath;
                videoMode = "interactive";
              }
            } else {
              videoURL = continuousVideoPath;
              videoMode = "continuous";
              if (
                interactiveVideoPath == null ||
                interactiveVideoPath == undefined
              ) {
                setVideoOption([
                  { value: "continuous", label: "Continuous Play" },
                ]);
              }
            }
          } else {
            if (interactiveVideoPath) {
              videoURL = interactiveVideoPath;
              videoMode = "interactive";
            } else {
              videoURL = continuousVideoPath;
              videoMode = "continuous";
              setVideoOption([
                { value: "continuous", label: "Continuous Play" },
              ]);
            }
          }
          setVideoURL(videoURL);
          setVideoMode(videoMode);
          setIsVideoLoading(false);
        } else {
          if (data.wkErrorCode) {
            handleException(data);
          }
        }
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error,
        );
      });
  };
  const handleUpdateRecntlyWatchedVideo = async () => {
    const reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          themisProductId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          themisSubjectAreaId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          pageNavigatingTo: "EReader",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
          ppSubjectAreaTagId: landingPageInfor.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: landingPageInfor.SATagId,
      ppSubTopicVO: {
        modeType: videoMode,
        subTopictagId: subtopictagid,
        productId: landingPageInfor.ProductID,
      },
    };
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(reqData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    await (
      await fetch(
        `${localStorage.getItem("ENV")}/managePP/updateLastWatchedVideo`,
        requestOptions,
      )
    ).json();
  };
  const isiOS26 = () => {
    const userAgent = navigator.userAgent;
    const isiPhone = /iPhone|iPad|iPod/.test(userAgent);
    const isSafari26 = /Version\/26\.0/.test(userAgent);

    return isiPhone && isSafari26;
  };
  const updateVideoTimeTracker = async (sec, totDuration, subTopictagId) => {
    if (sec == 0 || typeof sec == "undefined" || sec == null) {
      return true;
    }
    var selectVideoModeOption = $("#ppVideoFormat").val();
    var perTileVal = (sec / totDuration) * 100;
    const reqData = {
      userVO: {
        userId: userVO.userId,
        userRole: userVO.userRole,
        schoolId: userVO.schoolId,
        userRoleId: userVO.userRoleId,
        userActivityVO: {
          lastReadBookId: "",
          themisProductId: "",
          lastReadPageNum: "",
          lastReadChapterId: "",
          lastReadSectionId: "",
          lastReadParagraphId: "",
          themisSubjectAreaId: "",
          lastViewedOutlineId: "",
          lastReadSubSectionId: "",
          schoolId: userVO.schoolId,
          pageNavigatingTo: "EReader",
          lastActivityCode: "BOOKSHELF",
          pageNavigatingFrom: "Bookshelf",
          ppSubjectAreaTagId: landingPageInfor.SATagId,
        },
        sessionVO: getSessionVO(),
      },
      ppSubjectAreaTagId: landingPageInfor.SATagId,
      ppSubTopicVO: {
        timeSpent: sec,
        subTopictagId: subtopictagid,
        modeType: selectVideoModeOption,
        completionProgress: parseInt(perTileVal),
      },
    };
    const requestOptions = {
      method: "POST",
      keepalive: true,
      body: JSON.stringify(reqData),
      headers: {
        "Keep-Alive": true,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    await fetch(
      `${localStorage.getItem("ENV")}/managePP/updatePPVideoTimeTracker`,
      requestOptions,
    );
  };
  const onLoadVideoTracker = async () => {
    if (observer) {
      observer.disconnect();
    }
    let oldTime = 0;
    const iframe = document.getElementById("video");
    const contentWindow = iframe.contentWindow;
    if (
      iframe !== null &&
      iframe.contentWindow &&
      typeof iframe !== "undefined"
    ) {
      var config = { attributes: true, childList: true, subtree: true };
      async function domChanged() {
        var sec, totDuration;
        switch (videoMode) {
          case "interactive":
            if (typeof contentWindow.videojs != "undefined") {
              if (
                typeof contentWindow.videojs.getPlayers().wk_video !=
                "undefined"
              ) {
                var sec = contentWindow.videojs
                  .getPlayers()
                  .wk_video.currentTime();
                var totDuration = contentWindow.videojs
                  .getPlayers()
                  .wk_video.duration();
              }
              if (
                typeof contentWindow.videojs.getPlayers().vjs_video_3 !=
                "undefined"
              ) {
                var sec = contentWindow.videojs
                  .getPlayers()
                  .vjs_video_3.currentTime();
                var totDuration = contentWindow.videojs
                  .getPlayers()
                  .vjs_video_3.duration();
              }
            }
            break;
          case "continuous":
            if (typeof contentWindow.videojs != "undefined") {
              if (
                typeof contentWindow.videojs.getPlayers().wk_video !=
                "undefined"
              ) {
                var sec = contentWindow.videojs
                  .getPlayers()
                  .wk_video.currentTime();
                var totDuration = contentWindow.videojs
                  .getPlayers()
                  .wk_video.duration();
              }
              if (
                typeof contentWindow.videojs.getPlayers().vjs_video_3 !=
                "undefined"
              ) {
                var sec = contentWindow.videojs
                  .getPlayers()
                  .vjs_video_3.currentTime();
                var totDuration = contentWindow.videojs
                  .getPlayers()
                  .vjs_video_3.duration();
              }
            } else {
              var player = new contentWindow.Vimeo.Player(
                contentWindow.document.getElementsByTagName("iframe")[0],
              );
              sec = await player.getCurrentTime();
              totDuration = await player.getDuration();
            }
            break;
        }
        var subTopictagId = subtopictagid;
        updateVideoTimeTracker(sec, totDuration, subTopictagId);
      }
      observer = new MutationObserver(domChanged);
      observer.observe(iframe, config);
      switch (videoMode) {
        case "interactive":
          setTimeout(function () {
            if (typeof contentWindow.videojs != "undefined") {
              if (
                typeof contentWindow.videojs.getPlayers().wk_video !=
                "undefined"
              ) {
                contentWindow.videojs("wk_video").ready(function () {
                  this.errorDisplay.contentEl_.innerText =
                    "We’re having trouble loading this video. Please refresh your browser or try a different video mode.";
                  this.currentTime(ppVideo.interactiveTimeSpent);
                  this.on("play", function () {
                    document
                      .getElementById("ppwvIframeContainer")
                      .setAttribute("data-isvideoplayed", true);
                    handleUpdateRecntlyWatchedVideo();
                  });
                  this.on("seeked", function (event) {
                    windowUnload();
                  });
                  this.on("timeupdate", function (currenttime) {
                    var ctime = Math.round(this.currentTime());
                    if (ctime != oldTime && ctime % 10 == 0) {
                      oldTime = ctime;
                      windowUnload();
                    }
                  });
                });
              }
              if (
                typeof contentWindow.videojs.getPlayers().vjs_video_3 !=
                "undefined"
              ) {
                contentWindow.videojs("vjs_video_3").ready(function () {
                  this.errorDisplay.contentEl_.innerText =
                    "We’re having trouble loading this video. Please refresh your browser or try a different video mode.";
                  this.currentTime(ppVideo.interactiveTimeSpent);
                  this.on("play", function () {
                    document
                      .getElementById("ppwvIframeContainer")
                      .setAttribute("data-isvideoplayed", true);
                    handleUpdateRecntlyWatchedVideo();
                  });
                  this.on("seeked", function (event) {
                    windowUnload();
                  });
                  this.on("timeupdate", function (currenttime) {
                    var ctime = Math.round(this.currentTime());
                    if (ctime != oldTime && ctime % 10 == 0) {
                      oldTime = ctime;
                      windowUnload();
                    }
                  });
                });
              }
            } else {
              var player = new contentWindow.Vimeo.Player(
                contentWindow.document.getElementsByTagName("iframe")[0],
              );
              if (
                typeof ppVideo.interactiveTimeSpent != "undefined" &&
                ppVideo.interactiveTimeSpent != null
              ) {
                player
                  .setCurrentTime(ppVideo.interactiveTimeSpent)
                  .then(function (seconds) {});
              }
              player.on("play", function () {
                document
                  .getElementById("ppwvIframeContainer")
                  .setAttribute("data-isvideoplayed", true);
                handleUpdateRecntlyWatchedVideo();
              });
              player.on("seeked", function (event) {
                windowUnload();
              });
              player.on("timeupdate", function (currenttime) {
                var ctime = Math.round(currenttime.seconds);
                if (ctime != oldTime && ctime % 10 == 0) {
                  oldTime = ctime;
                  windowUnload();
                }
              });
            }
          }, 2000);
          break;
        case "continuous":
          setTimeout(function () {
            if (typeof contentWindow.videojs != "undefined") {
              if (
                typeof contentWindow.videojs.getPlayers().wk_video !=
                "undefined"
              ) {
                contentWindow.videojs("wk_video").ready(function () {
                  this.errorDisplay.contentEl_.innerText =
                    "We’re having trouble loading this video. Please refresh your browser or try a different video mode.";
                  this.currentTime(ppVideo.continuousTimeSpent);
                  this.on("play", function () {
                    document
                      .getElementById("ppwvIframeContainer")
                      .setAttribute("data-isvideoplayed", true);
                    handleUpdateRecntlyWatchedVideo();
                  });
                  this.on("seeked", function (event) {
                    windowUnload();
                  });
                  this.on("timeupdate", function (currenttime) {
                    var ctime = Math.round(this.currentTime());
                    if (ctime != oldTime && ctime % 10 == 0) {
                      oldTime = ctime;
                      windowUnload();
                    }
                  });
                });
              }
              if (
                typeof contentWindow.videojs.getPlayers().vjs_video_3 !=
                "undefined"
              ) {
                contentWindow.videojs("vjs_video_3").ready(function () {
                  this.errorDisplay.contentEl_.innerText =
                    "We’re having trouble loading this video. Please refresh your browser or try a different video mode.";
                  this.currentTime(ppVideo.continuousTimeSpent);
                  this.on("play", function () {
                    document
                      .getElementById("ppwvIframeContainer")
                      .setAttribute("data-isvideoplayed", true);
                    handleUpdateRecntlyWatchedVideo();
                  });
                  this.on("seeked", function (event) {
                    windowUnload();
                  });
                  this.on("timeupdate", function (currenttime) {
                    var ctime = Math.round(this.currentTime());
                    if (ctime != oldTime && ctime % 10 == 0) {
                      oldTime = ctime;
                      windowUnload();
                    }
                  });
                });
              }
            } else {
              var player = new contentWindow.Vimeo.Player(
                contentWindow.document.getElementsByTagName("iframe")[0],
              );
              if (
                typeof ppVideo.continuousTimeSpent != "undefined" &&
                ppVideo.continuousTimeSpent != null
              ) {
                player
                  .setCurrentTime(ppVideo.continuousTimeSpent)
                  .then(function (seconds) {});
              }
              player.on("play", function () {
                document
                  .getElementById("ppwvIframeContainer")
                  .setAttribute("data-isvideoplayed", true);
                handleUpdateRecntlyWatchedVideo();
              });
              player.on("seeked", function (event) {
                windowUnload();
              });
              player.on("timeupdate", function (currenttime) {
                var ctime = Math.round(currenttime.seconds);
                if (ctime != oldTime && ctime % 10 == 0) {
                  oldTime = ctime;
                  windowUnload();
                }
              });
            }
          }, 2000);
          break;
      }
    }
  };
  const vidChange = (e) => {
    document
      .getElementById("ppwvIframeContainer")
      .setAttribute("data-isvideoplayed", false);
    setVideoMode(e.target.value);
    switch (e.target.value) {
      case "interactive":
        setVideoURL(ppVideo.interactiveVideoPath);
        break;
      case "continuous":
        setVideoURL(ppVideo.continuousVideoPath);
        break;
    }
  };
  const windowUnload = async () => {
    var sec, totDuration;
    const iframe = document.getElementById("video");
    const contentWindow = iframe.contentWindow;
    if (
      !(
        iframe !== null &&
        iframe.contentWindow &&
        typeof iframe !== "undefined"
      )
    ) {
      return false;
    }
    if (
      document.querySelectorAll("[data-isvideoplayed]")[0].dataset
        .isvideoplayed == false
    ) {
      return false;
    }
    switch (videoMode) {
      case "interactive":
        if (typeof contentWindow.videojs != "undefined") {
          if (
            typeof contentWindow.videojs.getPlayers().wk_video != "undefined"
          ) {
            sec = contentWindow.videojs.getPlayers().wk_video.currentTime();
            totDuration = contentWindow.videojs
              .getPlayers()
              .wk_video.duration();
          }
          if (
            typeof contentWindow.videojs.getPlayers().vjs_video_3 != "undefined"
          ) {
            sec = contentWindow.videojs.getPlayers().vjs_video_3.currentTime();
            totDuration = contentWindow.videojs
              .getPlayers()
              .vjs_video_3.duration();
          }
        } else {
          var player = new contentWindow.Vimeo.Player(
            contentWindow.document.getElementsByTagName("iframe")[0],
          );
          sec = await player.getCurrentTime();
          totDuration = await player.getDuration();
        }
        break;
      case "continuous":
        if (typeof contentWindow.videojs != "undefined") {
          if (
            typeof contentWindow.videojs.getPlayers().wk_video != "undefined"
          ) {
            sec = contentWindow.videojs.getPlayers().wk_video.currentTime();
            totDuration = contentWindow.videojs
              .getPlayers()
              .wk_video.duration();
          }
          if (
            typeof contentWindow.videojs.getPlayers().vjs_video_3 != "undefined"
          ) {
            sec = contentWindow.videojs.getPlayers().vjs_video_3.currentTime();
            totDuration = contentWindow.videojs
              .getPlayers()
              .vjs_video_3.duration();
          }
        } else {
          var player = new contentWindow.Vimeo.Player(
            contentWindow.document.getElementsByTagName("iframe")[0],
          );
          sec = await player.getCurrentTime();
          totDuration = await player.getDuration();
        }
        break;
    }
    updateVideoTimeTracker(sec, totDuration, subtopictagid);
  };
  useEffect(() => {
    getPPvideoPagedetails();
    // $(window).bind('beforeunload', function (e) { windowUnload(); });
  }, []);
  useEffect(() => {
    if (isLandingPageInfor.current) {
      getPPVideoTracker();
    } else {
      isLandingPageInfor.current = true;
    }
  }, [landingPageInfor]);
  return (
    <>
      <Spinner
        loading={isVideoLoading}
        imageSrc={loaderColors1}
        overlayBackground="rgba(0,0,0,0.5)"
      />
      <Header
        userVO={userVO}
        pageName="CCPracticePerfect"
        isbn={ppIsbn}
        ppwvideoid={landingPageInfor.ProductID}
        time="test"
      ></Header>
      {ppVideo ? (
        <div className="container">
          <div className="card ppwvContainerSection">
            <div className="card-body ppwvContainerCard">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="ppwvLogoContainer">
                    <p>
                      <span className="ppwvCommonStyle ppwvLogoBoldText">
                        PracticePerfect<sup>TM</sup>
                      </span>
                      <span className="ppwvCommonStyle ppwvLogoText">
                        {" "}
                        {landingPageInfor.ProductName}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-8 col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="mt-3 ">
                    <p className="ppwvCommonStyle ppwvVideoTitle mb-2">
                      {ppVideo.customerFacingSubTopicName}
                    </p>
                  </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="ppwvVideoMode d-flex">
                    <div className="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-4 ppwvCommonStyle ppwvModelLabel p-0">
                      <label
                        htmlFor="ppVideoFormat"
                        className="ppwvCommonStyle ppwvModelLabel p-0"
                      >
                        Video Mode:
                      </label>
                    </div>
                    <div
                      className="col-xl-8 col-lg-9 col-md-8 col-sm-8 col-8 p-0"
                      style={{ paddingRight: "9px" }}
                    >
                      <select
                        data-testid="select_mode"
                        className="ppwvViewingInput form-control text-box-common"
                        value={videoMode}
                        id="ppVideoFormat"
                        onChange={(e) => vidChange(e)}
                        aria-label="Video Mode"
                      >
                        {videoOption.map((option, index) => (
                          <option key={index} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {ppVideo.totalQuestions ? (
                  <div className="ml-3">
                    <p className="ppwvCommonStyle ppwvTakeQuizText">
                      Take a Quiz:
                    </p>
                    <div className="d-flex">
                      <PPWatchVideoQuizButtons
                        video={ppVideo}
                        ppQuizResultVOList={ppQuizResultVOList}
                        landingPageInfor={landingPageInfor}
                        subtopictagid={subtopictagid}
                        isbn={ppIsbn}
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className="ppwvCommonStyle ml-3"
                    style={{ fontSize: "16px", color: "#757575" }}
                  >
                    There is no quiz for this video.
                  </div>
                )}
              </div>
              <div className="row mt-2">
                <div className="col-12">
                  <div
                    className="ppwvIframeContainer"
                    id="ppwvIframeContainer"
                    data-isvideoplayed="false"
                  >
                    {
                      <iframe
                        title="video content"
                        data-testid="video"
                        onLoad={onLoadVideoTracker}
                        style={{ position: "absolute" }}
                        className="w-100"
                        src={localStorage.getItem("BASE_URL") + videoURL}
                        id="video"
                        frameBorder="0"
                        width="100%"
                        height="100%"
                        allowFullScreen
                        scrolling="no"
                        sandbox="allow-scripts allow-same-origin"
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
export default withAuth(PPWatchVideo);
